import Vuetify from './components/Vuetify';
export default Vuetify;
export * from './components';
export { default as directives } from './directives';
export { default as colors } from './util/colors';
//# sourceMappingURL=index.js.map